import { render, staticRenderFns } from "./booklinkdialog.vue?vue&type=template&id=612020b2&scoped=true"
import script from "./booklinkdialog.vue?vue&type=script&lang=js"
export * from "./booklinkdialog.vue?vue&type=script&lang=js"
import style0 from "./booklinkdialog.vue?vue&type=style&index=0&id=612020b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612020b2",
  null
  
)

export default component.exports